
// Class that holds a specific sound playback configuration
export default class SoundMapEntry {
    /**
     * Sound Map entry object represents information
     * of an active sound instance. It should be
     * disposed when sound has finished playing
     * @param {*} clip  current sound value for the audio instance. starts at 1.0 and can be changed through setSoundVolume()
     * @param {*} id audio ID of the played sound
     * @param {*} soundSetting sound setting object used by the sound instance
     * @param {*} spriteName assigns sprite name if its an audiosprite. null if its not an audio sprite
     */
    constructor (clip, id, soundSetting, loop, spriteName = null) {
        // audio ID of the played sound
        this.id = id;
        // cc.AudioClip used for the playback
        this.clip = clip;
        // current sound value for the audio instance. starts at 1.0 and can be changed through setSoundVolume()
        this.volume = 1.0;
        // indicates sound playback is looped
        this.loop = loop;
        // indicates number of times sound is played consecutively
        this.count = 1;
        // callback function on end of playback. Also called on end of loop and consecutive playback if count != 0
        this.cb = null;
        // assigns sprite name if its an audiosprite. null if its not an audio sprite
        this.spritename = spriteName;
        // sound setting object used by the sound instance
        this.soundSetting = soundSetting;

    }

    /** returns calculated volume. clip.volume is assigned on playback and its value is retrieved from audio json */
    getVolume () {
        return this.volume * this.soundSetting.volume;
    }
}
